<!--
 * @Author: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @Date: 2025-06-16 12:02:05
 * @LastEditors: lee 15472300+li-shaoang@user.noreply.gitee.com
 * @LastEditTime: 2025-06-16 16:27:07
 * @FilePath: \zhucai_user\src\pages\member\child\info.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="my-container">
    <div class="my-title">账号安全</div>
    <div class="my-content">
      <div class="box">
        <div class="box-left">
          <img src="@/assets/img/member/31.png" alt="" class="img" />
          <div class="box-content">
            <div class="box-content-top">登录密码</div>
            <div class="box-content-bottom">
              建议您定期更换密码，设置安全性高的密码可以使帐号更安全
            </div>
          </div>
        </div>

        <div class="box-right">
          <el-button class="submit-btn" @click="toUrl('editPassword')">
            修改
          </el-button>
        </div>
      </div>
      <div class="box mt20">
        <div class="box-left">
          <img src="@/assets/img/member/32.png" alt="" class="img" />
          <div class="box-content">
            <div class="box-content-top">安全手机</div>
            <div class="box-content-bottom">
              安全手机可以用于登录帐号，重置密码或其他安全验证
            </div>
          </div>
        </div>

        <div class="box-right">
          <el-button class="submit-btn" @click="toUrl('editPhone')">
            修改
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getToken, setToken, removeToken } from "@/util/auth";

/* eslint-disable */
export default {
  name: "account",
  data() {
    return {
      form: {
        Avatar: "",
        RealName: "",
        NickName: "",
        Sex: 1,
        IDCard: "",
        Phone: "",
        OrgnID: "",
        IsManager: false,
        IsPartner: false,
      },
    };
  },

  methods: {
    toUrl(url) {
      this.$router.push({
        path: url,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.my-container {
  height: 810px;
  .my-title {
    font-size: 18px;
    color: #333333;
    padding: 0 25px;
    height: 68px;
    line-height: 68px;
    background: #ffffff;
    border-radius: 10px;
  }
  .my-content {
    padding: 25px;
    margin-top: 1px;
    height: 810px;
    background: #ffffff;
    border-radius: 10px;
    .box {
      width: 1360px;
      height: 124px;
      margin: 0 auto;
      padding: 25px;
      background: #f6f8fc;
      border-radius: 10px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .box-left {
        display: flex;
        align-items: center;
        img {
          width: 70px;
          height: 70px;
        }
        .box-content {
          margin-left: 20px;
          .box-content-top {
            font-size: 20px;
            color: #333333;
            margin-bottom: 5px;
          }
          .box-content-bottom {
            font-size: 16px;
            color: #666666;
          }
        }
      }
      .box-right {
        .submit-btn {
          width: 120px;
          height: 46px;
          background: #1d79ff;
          border-radius: 6px;
          font-size: 16px;
          color: #ffffff;
        }
      }
    }
  }
}
.mt20 {
  margin-top: 20px !important;
}
</style>